export default function Features() {
  const features = [
    {
      icon: 'ri-hd-line',
      title: '高清画质',
      description: '支持1080P和4K超清画质，极速加载不卡顿，带来沉浸式观影体验。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '每日更新',
      description: '热播剧集每日同步更新，最新电影第一时间上线，追剧不等待。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      description: '支持手机、平板、电脑多设备无缝切换，随时随地畅享观影乐趣。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '正版资源',
      description: '聚合妖精视频、桃花视频、苹果视频等主流平台正版资源，安全放心看。',
    },
    {
      icon: 'ri-search-eye-line',
      title: '智能推荐',
      description: '基于AI算法的个性化推荐，精准匹配你的观影口味，发现更多好剧。',
    },
    {
      icon: 'ri-vip-diamond-line',
      title: '完全免费',
      description: '无需付费会员，全部影视资源免费在线观看，省心又省钱。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">为什么选择嫩草视频</h2>
          <p className="text-foreground-600 text-sm">六大核心优势，打造极致观影体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat, i) => (
            <div key={i} className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 shrink-0">
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{feat.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}